module.exports = __webpack_public_path__ + "media/video.380d9ecf.mp4";